<nz-card [nzLoading]="loading">
  <div class="header-row">
    <h1>{{ (isEditMode ? 'ADMIN.PLATFORM_ANNOUNCEMENTS.EDIT_TITLE' : 'ADMIN.PLATFORM_ANNOUNCEMENTS.NEW_TITLE') | translate }}</h1>
    <button nz-button nzType="default" type="button" routerLink="/admin/platform-announcements">{{ 'COMMON.BACK' | translate }}</button>
  </div>

  <form [formGroup]="form" class="announcement-form" (ngSubmit)="save()">
    <div class="field">
      <label for="platform-announcement-message-de">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MESSAGE_DE' | translate }} *</label>
      <textarea id="platform-announcement-message-de" nz-input rows="5" maxlength="500" formControlName="messageDe"></textarea>
      <div class="field-error" *ngIf="form.controls['messageDe'].touched && form.controls['messageDe'].hasError('required')">
        {{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_MESSAGE_DE_REQUIRED' | translate }}
      </div>
      <div class="field-error" *ngIf="form.controls['messageDe'].touched && form.controls['messageDe'].hasError('maxlength')">
        {{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_MESSAGE_MAX_LENGTH' | translate:{max: maxMessageLength} }}
      </div>
    </div>

    <div class="field">
      <label for="platform-announcement-message-en">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MESSAGE_EN_OPTIONAL' | translate }}</label>
      <textarea id="platform-announcement-message-en" nz-input rows="5" maxlength="500" formControlName="messageEn"></textarea>
      <div class="help-text">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MESSAGE_EN_HELP' | translate }}</div>
      <div class="field-error" *ngIf="form.controls['messageEn'].touched && form.controls['messageEn'].hasError('maxlength')">
        {{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_MESSAGE_MAX_LENGTH' | translate:{max: maxMessageLength} }}
      </div>
    </div>

    <div class="field">
      <label for="platform-announcement-target">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.DESTINATION' | translate }}</label>
      <nz-select id="platform-announcement-target" formControlName="targetKind" [nzAllowClear]="true"
                 [nzPlaceHolder]="'ADMIN.PLATFORM_ANNOUNCEMENTS.TARGET_NONE' | translate">
        <nz-option [nzValue]="null" [nzLabel]="'ADMIN.PLATFORM_ANNOUNCEMENTS.TARGET_NONE' | translate"></nz-option>
        <nz-option *ngFor="let targetKind of targetKinds" [nzValue]="targetKind" [nzLabel]="targetLabel(targetKind)"></nz-option>
      </nz-select>
    </div>

    <div class="actions">
      <button nz-button nzType="default" type="button" routerLink="/admin/platform-announcements">{{ 'COMMON.CANCEL' | translate }}</button>
      <button nz-button nzType="primary" type="submit" [nzLoading]="saving">{{ 'COMMON.SAVE' | translate }}</button>
    </div>
  </form>
</nz-card>
